import type { PricedModifier } from "../../api/types";
import { t } from "../../i18n";
import { formatEuro } from "../../lib/money";

/**
 * An option as the prototype writes it (modsText): "+ Feta € 1,00", "+ Samourai (gratis)" (one of the
 * free picks), "> Penne" (a required choice), "! Goed doorbakken" (an instruction), "− Ui" and
 * "Zonder groenten"; "Enkel sla, tomaat" as the server wrote it. The receipt and the kitchen get them
 * without prices.
 */
export function describeModifier(modifier: PricedModifier, withPrice = true): string {
  if (modifier.kind === "without") {
    return modifier.name === t.product.allVegetables ? modifier.name : `− ${modifier.name}`;
  }
  if (modifier.kind === "only") return modifier.name;
  if (modifier.kind === "instruction") return `! ${modifier.name}`;
  const sign = modifier.kind === "choice" ? ">" : "+";
  if (!withPrice) return `${sign} ${modifier.name}`;
  if (modifier.cents > 0) return `${sign} ${modifier.name} ${formatEuro(modifier.cents)}`;
  return modifier.free === true ? `${sign} ${modifier.name} (${t.sale.freeLabel})` : `${sign} ${modifier.name}`;
}

/** The kitchen note of a line, as the prototype shows it: "✎ goed gebakken". */
export const noteText = (note: string) => `✎ ${note}`;
